import { render } from "./FloatingFaq.vue?vue&type=template&id=31f6f8b6&scoped=true&lang=pug"
import script from "./FloatingFaq.vue?vue&type=script&lang=js"
export * from "./FloatingFaq.vue?vue&type=script&lang=js"

import "./FloatingFaq.vue?vue&type=style&index=0&id=31f6f8b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f6f8b6"]])

export default __exports__